module.exports = "/assets/src/client/assets/payment-icons/mollie/wero.svg";